import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { determineDeliveryTimeTranslationKey } from "@omni/components/utils/deliveryPromise";
import { hasNoStock } from "@omni/components/utils/productAvailability";
import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";

type Props = {
    productAvailability?: CloudProductAvailability;
};

const Stock = ({ productAvailability }: Props) => {
    const { t } = useGranite();

    let className = "text-success";
    const icon = "la-check";

    if (
        hasNoStock(
            productAvailability?.realTimeStockAvailable,
            productAvailability?.stockLevel,
            productAvailability?.realTimeStock
        )
    ) {
        return null;
    }
    const tk =
        determineDeliveryTimeTranslationKey(
            productAvailability?.deliveryPromiseType,
            productAvailability?.stockLevel,
            productAvailability?.realTimeStockAvailable,
            productAvailability?.realTimeStock,
            true
        ) || "";

    if (
        productAvailability?.deliveryPromiseType ===
        CloudDeliveryPromiseType.AvailableForS2S
    ) {
        className = "";
    } else if (
        !productAvailability?.realTimeStockAvailable &&
        productAvailability?.stockLevel === CloudStockLevel.LowStock
    ) {
        className = "text-warning";
    }

    const deliveryTimeUnitTk = `product.deliveryPromise.timeUnits.${productAvailability?.deliveryTimeUnit}`;

    return (
        <span className={className}>
            <i className={`las ${icon} mr-1`} />
            {tk &&
                t(
                    tk,
                    productAvailability?.deliveryTime,
                    t(deliveryTimeUnitTk),
                    productAvailability?.realTimeStock
                )}
        </span>
    );
};

export { Stock };
